const DEFAULT_CACHE_TIME = 3 * 60;
const DEFAULT_DEADLINE = 300; // 5 min
const configRef = {
    gamesCacheTime: DEFAULT_CACHE_TIME,
};
const cookieKeys = {
    appChainId: 'appChainId',
    live: 'live',
};
const localStorageKeys = {
    betslipItems: 'betslipItems',
};export{DEFAULT_DEADLINE as D,configRef as a,cookieKeys as c,localStorageKeys as l};